import { XOL_RECOVERY_INIT_LOADING, XOL_RECOVERY_INIT_SUCCESS, XOL_RECOVERY_INIT_FAIL, XOL_RECOVERY_SELECT } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import clone from 'clone'

export const initialState = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  id: {
  }
}

export const getters = {

}

export const mutations = {
  [XOL_RECOVERY_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [XOL_RECOVERY_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [XOL_RECOVERY_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [XOL_RECOVERY_SELECT](state, data) {
    state.id = data
  }
}

const actions = {
  async xolRecoveryInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.xolRecovery
    commit(XOL_RECOVERY_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(XOL_RECOVERY_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(XOL_RECOVERY_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
